import React from 'react';
import PropTypes from 'prop-types';
import {withStyles, TableHead, TableRow, TableCell} from "@material-ui/core";
import t from "../../../languages/pl";

const useStyles = theme => ({
    row: { },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    }
});

const TableHeader = ({classes}) => {
    return (
        <TableHead>
            <TableRow className={classes.row}>
                <TableCell className={classes.cell}>
                    {t.ordinalNumber}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.name}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.type2}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.fileName}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.cycle}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.emailAddressLabel}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.manage}
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

TableHeader.propTypes = {
    classes: PropTypes.object
};

export default withStyles(useStyles)(TableHeader);
